import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeMegaColumn, setActiveMegaColumn] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setActiveDropdown(null); // Reset dropdowns when menu closes
    setActiveMegaColumn(null); // Reset mega menu columns when menu closes
    setActiveSubDropdown(null); // Reset sub-dropdowns when menu closes
    document.body.style.overflow = !isMenuOpen ? 'hidden' : ''; // Prevent scrolling when menu is open
  };

  const handleDropdownToggle = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
    setActiveMegaColumn(null); // Reset mega menu columns when switching dropdowns
  };

  const handleMegaColumnToggle = (columnIndex) => {
    setActiveMegaColumn(activeMegaColumn === columnIndex ? null : columnIndex);
  };

  const handleSubDropdownToggle = (parentIndex, subIndex) => {
    const key = `${parentIndex}-${subIndex}`;
    setActiveSubDropdown(activeSubDropdown === key ? null : key);
  };

  const handleSmoothScroll = (e, route) => {
    if (route.startsWith('/#')) {
      e.preventDefault();
      const targetId = route.substring(2);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Close mobile menu if open
        if (isMobile && isMenuOpen) {
          setIsMenuOpen(false);
          setActiveDropdown(null);
          setActiveMegaColumn(null);
          setActiveSubDropdown(null);
          document.body.style.overflow = '';
        }
      }
    }
  };

  // First row navigation items
  const navItemsRow1 = [
    {
      name: "HOME",
      route: "/",
      dropdown: [] // No dropdown for home
    },
    {
      name: "ABOUT",
      route: "/about",
      dropdown: [
        { name: "About RUK", route: "/about/ruk" },
        { name: "About EMBLEM", route: "/about/emblem" },
        { name: "Gallery", route: "/about/gallery" },
        { name: "Vice Chancellor's Message", route: "/about/vc-message" },
        { name: "Succesive Vice Chancellors", route: "/about/successive-vcs" },
        { name: "Vision & Mission", route: "/about/vision" }
      ]
    },
    {
      name: "ADMINISTRATION",
      route: "/administration",
      dropdown: [
        { name: "Vice Chancellor", route: "/administration/vice-chancellor" },
        // { name: "Rector", route: "/administration/rector" },
        { name: "Registrar", route: "/administration/registraroffice" },
        {
          name: "Principal",
          route: "#",
          subDropdown: [
            { name: "University College Principal", route: "/academics/college-of-science#principal" },
            { name: "Engineering College Principal", route: "/academics/engineering-college#principal" }
          ]
        },
        { name: "Executive Council", route: "/administration/executive-council" },
        { name: "University Officials", route: "/administration/officials" }
      ]
    },
    {
      name: "ACADEMICS",
      route: "/academics",
      dropdown: [
        {
          name: "University College",
          route: "#",
          subDropdown: [
            { name: "Department of Bio-Technology", route: "/academics/biotechnology" },
            { name: "Department of Botany", route: "/academics/botany" },
            { name: "Department of Business Management", route: "/academics/business-management" },
            { name: "Department of Chemistry", route: "/academics/chemistry" },
            { name: "Department of Commerce", route: "/academics/commerce" },
            { name: "Department of Computer Science", route: "/academics/computer-science" },
            { name: "Department of Economics", route: "/academics/economics" },
            { name: "Department of English", route: "/academics/english" },
            { name: "Department of Food Science and Nutrition", route: "/academics/food-science" },
            { name: "Department of Mathematics", route: "/academics/mathematics" },
            { name: "Department of OR & SQC (Statistics)", route: "/academics/statistics" },
            { name: "Department of Physics", route: "/academics/physics" },
            { name: "Department of Telugu", route: "/academics/telugu" },
            { name: "Department of Zoology", route: "/academics/zoology" }
          ]
        },
        {
          name: "College of Engineering",
          route: "#",
          subDropdown: [
            { name: "Department of Artificial Intelligence", route: "/academics/ai" },
            { name: "Department of Computer Science and Engineering", route: "/academics/cse" },
            { name: "Department of Electronics and Communication", route: "/academics/electronics" },
            { name: "Department of Civil Engineering", route: "/academics/civil" },
            { name: "Department of Mechanical Engineering", route: "/academics/mechanical" },
            { name: "Department of Humanities & Basic Sciences", route: "/academics/humanities-basic-sciences" }
          ]
        }
      ]
    },
    {
      name: "STUDENT CORNER",
      route: "/#student-corner",
      dropdown: [
        { name: "Ict-Labs", route: "/campuslife/ict-labs" },
        { name: "Science Labs", route: "/campuslife/science-labs" },
        // { name: "Hostels", route: "/hostels" },
        { name: "NSS", route: "/campuslife/nss" },
        { name: "Sports", route: "/campuslife/sports" },
        { name: "Auditorium", route: "/campuslife/auditorium" },
        // {name: "leave portal", route: "/leave-portal"},

        { name: "Campus Map", route: "/campuslife/college-buildings" },
      ]
    },
    {
      name: "EXAM CELL",
      route: "/examcell",
      dropdown: [
        { name: "About Exam Cell", route: "/examcell" },
        { name: "Results", route: "https://ruk.ac.in/results/" }
      ]
    },
    {
      name: "PLACEMENT CELL",
      route: "/placementcell",
      dropdown: [
        // { name: "About Placement Cell", route: "/placementcell/about" },
        // { name: "Placement Committee", route: "/placementcell/committee" }
      ]
    },
    {
      name: "LIBRARY",
      route: "/library",
      dropdown: []
    },

    {
      name: "CONTACT US",
      route: "/more/contact",
      dropdown: []
    }
  ];

  // Second row navigation items
  const navItemsRow2 = [
    {
      name: "RESEARCH",
      route: "/research",
      dropdown: []
    },
    {
      name: "ADMISSIONS",
      route: "/admission",
      dropdown: []
    },
    {
      name: "IQAC",
      route: "/administration/iqac",
      dropdown: []
    },
    {
      name: "CDC",
      route: "/administration/college-development",
      dropdown: []
    },
    {
      name: "ACADEMIC AFFAIRS",
      route: "/academic",
      dropdown: []
    },

    {
      name: "leave portal",
      route: "/leave-portal",
      dropdown: []
    }
    ,

    {
      name: "Innovation & Incubation Center",
      route: "/innovation-incubation-centre",
      dropdown: []
    },
    {
      name: "Digital Flora",
      route: "/digital-flora",
      dropdown: [
        { name: "Digital Flora", route: "/digital-flora" },
        { name: "QR Flora", route: "/digital-flora/qr-gallery" },
      ]
    },
    {
      name: "DISTANCE EDU",
      route: "/distance-education",
      dropdown: []
    },
    {
      name: "MORE",
      route: "/more",
      dropdown: [
        // { name: "Ict-Labs", route: "/campuslife/ict-labs" },
        // { name: "Science Labs", route: "/campuslife/science-labs" },
        // // { name: "Hostels", route: "/hostels" },
        // { name: "NSS", route: "/campuslife/nss" },
        // { name: "Sports", route: "/campuslife/sports" },
        // { name: "Auditorium", route: "/campuslife/auditorium" },
        {name:"Feedback Portal", route:"https://ruonlinefeedbacksystem.vercel.app/"},
        { name: "leave portal", route: "/leave-portal" },
        { name: "Gallary", route: "/about/gallery" },
        { name: "Student ERP", route: "/student-erp" },

        // { name: "Campus Map", route: "/campuslife/college-buildings" },
        { name: "All Notifications", route: "/more/notifications" },


      ]
    },
  ];

  return (
    <nav className="navbar">
      {/* Header/Branding Area */}
      <div className="navbar-header">
        <div className="navbar-container">
          <div className="navbar-branding">

            {/* Left side - English text */}
            <div className="navbar-logo gov-logo">
              <img src="/APgov.png" alt="Government of AP Logo" />
            </div>
            <div className="navbar-logo ugc-logo">
              <img src="/star.png" alt="UGC Logo" style={{ borderRadius: '50%' }} />
            </div>

            <div className="navbar-title-english">
              <span className="navbar-acronym">A State University</span>
              <h1>Rayalaseema University</h1>
              <p className="navbar-tagline">Kurnool, Andhra Pradesh</p>
            </div>

            {/* Center - Logos */}
            <div className="navbar-logos">


              <div className="navbar-logo university-logo">
                <img src="/logo.png" alt="Rayalaseema University Logo" />
              </div>

            </div>

            {/* Right side - Telugu text */}
            <div className="navbar-title-telugu">
              <span className="navbar-acronym">రాష్ట్ర విశ్వవిద్యాలయం</span>
              <h1>రాయలసీమ విశ్వవిద్యాలయం</h1>
              <p className="navbar-tagline">కర్నూలు, ఆంధ్రప్రదేశ్</p>
            </div>
            <div className="navbar-logo naac-logo">
              <img src="/naac4.png" alt="NAAC B Grade Logo" style={{ width: '180px', height: '180px' }} />
            </div>
            <div className="navbar-logo naac-logo">
              <img src="/ncte.png" alt="NCTE Logo" />
            </div>
            {/* Hamburger Menu Button for Mobile */}
            <button
              className={`navbar-hamburger ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Navigation Menu */}
      <div className={`navbar-navigation ${isMenuOpen && isMobile ? 'mobile-open' : ''}`}>
        <div className="navbar-container">

          {/* First Row Navigation Menu */}
          <div className={`navbar-menu navbar-menu-row1 ${isMenuOpen ? 'open' : ''}`}>
            <ul>
              {navItemsRow1.map((item, index) => (
                <li
                  key={index}
                  className={`nav-item ${(item.dropdown.length > 0 || item.megaMenu) ? 'has-dropdown' : ''} ${activeDropdown === index ? 'dropdown-active' : ''}`}
                  onMouseEnter={() => !isMobile && (item.dropdown.length > 0 || item.megaMenu) && handleDropdownToggle(index)}
                  onMouseLeave={() => !isMobile && (item.dropdown.length > 0 || item.megaMenu) && handleDropdownToggle(null)}
                >
                  <a
                    href={item.route}
                    onClick={(e) => {
                      if ((item.dropdown?.length > 0 || item.megaMenu) && isMobile) {
                        e.preventDefault();
                        handleDropdownToggle(index);
                      } else {
                        handleSmoothScroll(e, item.route);
                      }
                    }}
                  >
                    {item.name}
                    {(item.dropdown?.length > 0 || item.megaMenu) && <span className="dropdown-arrow">▼</span>}
                  </a>

                  {/* Mega Menu for Academics */}
                  {item.megaMenu && item.columns && (
                    <div className={`mega-menu ${activeDropdown === index ? 'show' : ''}`}>
                      <div className="mega-menu-container">
                        {item.columns.map((column, columnIndex) => (
                          <div key={columnIndex} className="mega-menu-column">
                            {/* Mobile: Make college headings clickable to expand departments */}
                            <h3
                              className={`mega-menu-heading ${isMobile ? 'mobile-clickable' : ''}`}
                              onClick={() => isMobile && handleMegaColumnToggle(columnIndex)}
                            >
                              {column.heading}
                              {isMobile && (
                                <span className={`mega-dropdown-arrow ${activeMegaColumn === columnIndex ? 'rotated' : ''}`}>
                                  ▼
                                </span>
                              )}
                            </h3>
                            <div className={`mega-menu-links ${isMobile && activeMegaColumn !== columnIndex ? 'mobile-hidden' : ''}`}>
                              {column.links.map((link, linkIndex) => (
                                <a
                                  key={linkIndex}
                                  href={link.route}
                                  className="mega-menu-link"
                                  onClick={() => {
                                    // Close mobile menu when a link is clicked
                                    if (isMobile) {
                                      setIsMenuOpen(false);
                                      setActiveDropdown(null);
                                      setActiveMegaColumn(null);
                                      document.body.style.overflow = '';
                                    }
                                  }}
                                >
                                  {link.name}
                                </a>
                              ))}
                            </div>
                            {columnIndex < item.columns.length - 1 && <div className="vertical-divider"></div>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Regular Dropdown Menu */}
                  {item.dropdown && item.dropdown.length > 0 && !item.megaMenu && (
                    <div className={`dropdown-menu ${activeDropdown === index ? 'show' : ''}`}>
                      {item.dropdown.map((dropdownItem, dropdownIndex) => (
                        <div
                          key={dropdownIndex}
                          className={`dropdown-item-wrapper ${dropdownItem.subDropdown ? 'has-subdropdown' : ''}`}
                          onMouseEnter={() => !isMobile && dropdownItem.subDropdown && handleSubDropdownToggle(index, dropdownIndex)}
                          onMouseLeave={() => !isMobile && dropdownItem.subDropdown && setActiveSubDropdown(null)}
                        >
                          <a
                            href={dropdownItem.route}
                            className="dropdown-item"
                            onClick={(e) => {
                              if (dropdownItem.subDropdown && isMobile) {
                                e.preventDefault();
                                handleSubDropdownToggle(index, dropdownIndex);
                              } else {
                                handleSmoothScroll(e, dropdownItem.route);
                                if (isMobile) {
                                  // Close mobile menu when a link is clicked
                                  setIsMenuOpen(false);
                                  setActiveDropdown(null);
                                  setActiveMegaColumn(null);
                                  setActiveSubDropdown(null);
                                  document.body.style.overflow = '';
                                }
                              }
                            }}
                          >
                            {dropdownItem.name}
                            {dropdownItem.subDropdown && <span className="subdropdown-arrow">▶</span>}
                          </a>

                          {/* Sub-dropdown Menu */}
                          {dropdownItem.subDropdown && (
                            <div className={`subdropdown-menu ${activeSubDropdown === `${index}-${dropdownIndex}` ? 'show' : ''}`}>
                              {dropdownItem.subDropdown.map((subItem, subIndex) => (
                                <a
                                  key={subIndex}
                                  href={subItem.route}
                                  className="subdropdown-item"
                                  onClick={() => {
                                    if (isMobile) {
                                      setIsMenuOpen(false);
                                      setActiveDropdown(null);
                                      setActiveMegaColumn(null);
                                      setActiveSubDropdown(null);
                                      document.body.style.overflow = '';
                                    }
                                  }}
                                >
                                  {subItem.name}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Second Row Navigation Menu */}
          <div className={`navbar-menu navbar-menu-row2 ${isMenuOpen ? 'open' : ''}`}>
            <ul>
              {navItemsRow2.map((item, index) => (
                <li
                  key={index}
                  className={`nav-item ${(item.dropdown.length > 0 || item.megaMenu) ? 'has-dropdown' : ''} ${activeDropdown === `row2-${index}` ? 'dropdown-active' : ''}`}
                  onMouseEnter={() => !isMobile && (item.dropdown.length > 0 || item.megaMenu) && setActiveDropdown(`row2-${index}`)}
                  onMouseLeave={() => !isMobile && (item.dropdown.length > 0 || item.megaMenu) && setActiveDropdown(null)}
                >
                  <a
                    href={item.route}
                    onClick={(e) => {
                      if ((item.dropdown?.length > 0 || item.megaMenu) && isMobile) {
                        e.preventDefault();
                        setActiveDropdown(activeDropdown === `row2-${index}` ? null : `row2-${index}`);
                      } else {
                        handleSmoothScroll(e, item.route);
                      }
                    }}
                  >
                    {item.name}
                    {(item.dropdown?.length > 0 || item.megaMenu) && <span className="dropdown-arrow">▼</span>}
                  </a>

                  {/* Regular Dropdown Menu for Row 2 */}
                  {item.dropdown && item.dropdown.length > 0 && !item.megaMenu && (
                    <div className={`dropdown-menu ${activeDropdown === `row2-${index}` ? 'show' : ''}`}>
                      {item.dropdown.map((dropdownItem, dropdownIndex) => (
                        <a
                          key={dropdownIndex}
                          href={dropdownItem.route}
                          className="dropdown-item"
                          onClick={(e) => {
                            handleSmoothScroll(e, dropdownItem.route);
                            if (isMobile) {
                              setIsMenuOpen(false);
                              setActiveDropdown(null);
                              setActiveMegaColumn(null);
                              setActiveSubDropdown(null);
                              document.body.style.overflow = '';
                            }
                          }}
                        >
                          {dropdownItem.name}
                        </a>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;